// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type SetFocusedInboxConfigurationRequest from '../contract/SetFocusedInboxConfigurationRequest';

export default function setFocusedInboxConfigurationRequest(
    data: SetFocusedInboxConfigurationRequest
): SetFocusedInboxConfigurationRequest {
    const result: SetFocusedInboxConfigurationRequest = {
        __type: 'SetFocusedInboxConfigurationRequest:#Exchange',
        ...data,
    };

    return result;
}
